/**
 * UTM Tracking
 * --------------------------------------------------------------------------
 * Leest UTM-parameters uit de URL en slaat ze op in sessionStorage, zodat ze
 * later (bijv. bij een lease-aanvraag) meegestuurd kunnen worden.
 *
 * Moet op ELKE pagina geladen worden — de klant kan op elke pagina landen.
 * Laden in theme.liquid:
 *   <script src="{{ 'utm-tracking.js' | asset_url }}" defer="defer"></script>
 *
 * Robuust tegen timing: sommige (live) storefronts/apps zetten de UTM's pas
 * NA de eerste scriptuitvoering in de URL (redirect of History API). Daarom
 * proberen we te vangen op meerdere momenten i.p.v. alleen direct.
 *
 * Attributiemodel: LAST-TOUCH per hele set. Zodra de URL minstens één
 * UTM-parameter bevat, wordt de volledige set vervangen.
 */
(function () {
  'use strict';

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_id', 'utm_term', 'utm_content'];

  function captureUtmParams() {
    var params;
    try {
      params = new URLSearchParams(window.location.search);
    } catch (e) {
      return;
    }

    // Bevat deze URL minstens één (niet-lege) UTM-parameter?
    var hasUtm = UTM_KEYS.some(function (key) {
      return params.has(key) && params.get(key);
    });
    if (!hasUtm) return; // Niets te vangen → bestaande waarden laten staan

    try {
      UTM_KEYS.forEach(function (key) {
        var value = params.get(key);
        if (value) {
          sessionStorage.setItem(key, value);
        } else {
          sessionStorage.removeItem(key);
        }
      });
    } catch (e) {
      // sessionStorage niet beschikbaar
    }
  }

  function alreadyStored() {
    return UTM_KEYS.some(function (key) {
      try {
        return !!sessionStorage.getItem(key);
      } catch (e) {
        return false;
      }
    });
  }

  // 1) Direct proberen.
  captureUtmParams();

  // 2) Nogmaals zodra de pagina verder geladen is.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', captureUtmParams);
  }
  window.addEventListener('load', captureUtmParams);

  // 3) Wanneer een app de URL aanpast via de History API of back/forward.
  window.addEventListener('popstate', captureUtmParams);
  ['pushState', 'replaceState'].forEach(function (method) {
    var original = history[method];
    if (typeof original === 'function') {
      history[method] = function () {
        var result = original.apply(this, arguments);
        captureUtmParams();
        return result;
      };
    }
  });

  // 4) Vangnet: kort napollen voor het geval de URL met vertraging gevuld wordt.
  //    Stopt zodra er iets is opgeslagen, of na ~5 seconden.
  var tries = 0;
  var poll = setInterval(function () {
    tries++;
    captureUtmParams();
    if (alreadyStored() || tries >= 10) {
      clearInterval(poll);
    }
  }, 500);
})();
